import { useQuery } from '@tanstack/react-query';
import { httpJSON } from '../../../shared/api/http';

export const STATS_REFRESH_MS = 15_000;

export function usePriceStatsQuery(options = {}) {
  return useQuery({
    queryKey: ['stats', 'price'],
    queryFn: () => httpJSON('/v1/stats'),
    staleTime: 60_000,
    refetchInterval: STATS_REFRESH_MS,
    refetchIntervalInBackground: true,
    ...options,
  });
}
